import { authFetch, sapFetch } from "../../api";

export const getDocType = async () => {
  try {
    const response = await authFetch(`document-type/get-all-document-stages`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching DocType:", err.message);
    throw err;
  }
};

export const getDocSubType = async (payload) => {
  try {
    const response = await authFetch(`document-type/get-documents-from-types`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching DocType:", err.message);
    throw err;
  }
};

export const uploadDocumentAPI = async (formData) => {
  try {
    const response = await authFetch(`document-file/add-files`, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Failed to upload: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error uploading document:", err.message);
    throw err;
  }
};

// get all documents of a user
export const getAllDocuments = async (payload) => {
  try {
    const response = await authFetch(`document-file/user-documents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching documents:", err.message);
    throw err;
  }
};

export const deleteDocumentAPI = async (payload) => {
  try {
    const response = await authFetch(`document-file/delete-user-documents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Failed to delete: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error deleting document:", err.message);
    throw err;
  }
};

export const fetchAllDocuments = async () => {
  try {
    const response = await fetch(
      `http://localhost:3002/api/student/document-type/get-all-document-types`,
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching documents:", err.message);
    throw err;
  }
};
